import React from "react";
import { Link } from "react-router-dom";

export default function JerseyCard({ jersey }) {
  return (
    <Link
      to={`/shop/${jersey.id}`}
      data-testid={`jersey-card-${jersey.id}`}
      className="fz-card block group"
    >
      <div className="aspect-square overflow-hidden border-b border-[#332D2B] bg-[#2A2320] relative">
        <img
          src={jersey.image_url}
          alt={jersey.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {jersey.featured ? (
          <div className="absolute top-3 right-3 bg-[#C8A96A] text-[#0F0C0B] px-2 py-1 font-mono-retro text-[10px] tracking-[0.3em] uppercase">
            Featured
          </div>
        ) : null}
        {jersey.stock <= 0 ? (
          <div className="absolute inset-0 bg-[#0F0C0B]/70 flex items-center justify-center">
            <span className="font-display text-2xl text-[#C8A96A] tracking-wider">SOLD OUT</span>
          </div>
        ) : null}
      </div>
      <div className="p-5">
        <div className="font-mono-retro text-[10px] tracking-[0.3em] text-[#756F6B] uppercase">{jersey.team} · {jersey.season}</div>
        <h3 className="font-display text-xl text-[#F2EBDD] mt-1 leading-tight">{jersey.name}</h3>
        <div className="font-body text-sm text-[#A8A39D] mt-1">{jersey.player}</div>
        <div className="flex items-center justify-between mt-4">
          <div className="font-display text-2xl text-[#C8A96A]">£{jersey.price}</div>
          <div className="font-mono-retro text-[10px] tracking-[0.3em] text-[#A8A39D] uppercase">
            {jersey.stock > 0 ? "In Stock" : "Sold Out"}
          </div>
        </div>
      </div>
    </Link>
  );
}
